import { render, staticRenderFns } from "./SectionSubportions.vue?vue&type=template&id=3f7d8d64&scoped=true&"
import script from "./SectionSubportions.vue?vue&type=script&lang=js&"
export * from "./SectionSubportions.vue?vue&type=script&lang=js&"
import style0 from "./SectionSubportions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SectionSubportions.vue?vue&type=style&index=1&id=3f7d8d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7d8d64",
  null
  
)

export default component.exports